import {
  useTroubleshootReferenceCauses,
} from "../../utils/ticket/TicketTroubleshootRefrences";

export default function TroubleshootCauseSelect({
  locationId,
  value,
  onChange,
  manualValue,
  onManualChange,
  required,
  disabled,
}) {
  const { data: causes, loading } = useTroubleshootReferenceCauses(locationId);
  const showManual = value && causes.find((cause) => cause.id === value)?.manual_input;

  return (
    <div className="form-group">
      <label>
        Penyebab Masalah {required && <span className="text-danger">*</span>}
      </label>
      <select
        className="form-control"
        value={value}
        onChange={onChange}
        required={required}
        disabled={disabled}
      >
        <option value="">-- Pilih Penyebab --</option>
        {loading ? (
          <option>Loading...</option>
        ) : (
          causes.map((cause) => (
            <option key={cause.id} value={cause.id}>
              {cause.name}
            </option>
          ))
        )}
      </select>
      {showManual && (
        <input
          type="text"
          className="form-control mt-2"
          value={manualValue}
          onChange={onManualChange}
          placeholder="Masukkan penyebab manual..."
          required
        />
      )}
    </div>
  );
}
